import { render, staticRenderFns } from "./spinnerSM.vue?vue&type=template&id=24099de8&scoped=true"
var script = {}
import style0 from "./spinnerSM.vue?vue&type=style&index=0&id=24099de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24099de8",
  null
  
)

export default component.exports